import React, { FC, ReactElement } from 'react';
import MainPage from './components/MainPage/MainPage';
import { CompetitionsProvider } from './context/context';

import '../scss/app.scss';

const App: FC = (): ReactElement => {
  return (
    <CompetitionsProvider>
      <MainPage />
    </CompetitionsProvider>
  );
};

export default App;
